import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import TitleReveal from '@/components/base/TitleReveal';
import { advantages } from '@/mocks/services';

export default function WhyMendwell() {
  return (
    <section className="bg-background-50 py-20 md:py-32 border-t border-background-200/70">
      <Container>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16">
          <Eyebrow label="Why MENDWELL" />
          <TitleReveal className="text-[34px] md:text-[48px] lg:text-[54px] font-medium leading-[1.05] tracking-[-0.025em] text-foreground-950">
            Repair Service, Thoughtfully Run.
          </TitleReveal>
        </div>
        <div className="mt-16 md:mt-24">
          {advantages.map((a, i) => (
            <div key={a.title} className="grid grid-cols-1 gap-4 border-t border-background-200 py-8 md:py-10 lg:grid-cols-2 lg:gap-16 last:border-b">
              <span className="text-[72px] md:text-[112px] font-light leading-[0.85] tracking-[-0.04em] text-primary-400">{`0${i + 1}`}</span>
              <div className="lg:pt-3">
                <h3 className="text-lg md:text-xl font-medium uppercase tracking-[0.04em] text-foreground-950">{a.title}</h3>
                <p className="mt-3 max-w-md text-[15px] leading-relaxed text-foreground-600">{a.text}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}